import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Box,
  Card,
  CardContent,
  Typography,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axios from "axios";
import BASE_URL from "../config";

const AddStaff = () => {
  const [staff, setStaff] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    qualification: "",
    designation: "",
    specialization: "",
    photo: null,
  });
  const [editingId, setEditingId] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  
  const fetchStaff = async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}/api/staff?page=${page + 1}&limit=${rowsPerPage}`);
      setStaff(data.data);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, [page, rowsPerPage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    try {
      if (editingId) {
        await axios.put(`${BASE_URL}/api/staff/${editingId}`, form);
        setSnackbar({ open: true, message: "Staff updated successfully!", severity: "success" });
      } else {
        await axios.post(`${BASE_URL}/api/staff`, form);
        setSnackbar({ open: true, message: "New staff added successfully!", severity: "success" });
      }
      fetchStaff();
      setEditingId(null);
      setFormData({ name: "", qualification: "", designation: "", specialization: "", photo: null });
    } catch (error) {
       //console.error("Error submitting form:", error.response?.data || error.message);
       const errorMessage = error.response?.data?.message || "An error occurred!";

      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    }
  };

  const handleEdit = (staff) => {
    setEditingId(staff.staff_id);
    setFormData({
      name: staff.name,
      qualification: staff.qualification,
      designation: staff.designation,
      specialization: staff.specialization,
      photo: null,
    });
    //window.scrollTo({ top: 0, behavior: "smooth" });
     // Target the specific scrollable container
  /* const scrollableContainer = document.querySelector('.dashboard-container');
  if (scrollableContainer) {
    scrollableContainer.scrollTo({ top: 0, behavior: "smooth" });
  } */
    // Scroll to the top of #root or the container
    const container = document.querySelector('#root');
    container.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/staff/${id}`);
      setSnackbar({ open: true, message: "Staff deleted successfully!", severity: "success" });
      fetchStaff();
    } catch (error) {
      setSnackbar({ open: true, message: "An error occurred while deleting!", severity: "error" });
    }
  };

  const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false });

  return (
    <Box p={3} display="flex" flexDirection="column" alignItems="center">
      <Card style={{ maxWidth: "600px", width: "100%" }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {editingId ? "Update Staff" : "Add New Staff"}
          </Typography>
          <form onSubmit={handleSubmit} style={{ display: "grid", gap: "15px" }}>
            <TextField
              label="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
            <TextField
              label="Qualification"
              value={formData.qualification}
              onChange={(e) => setFormData({ ...formData, qualification: e.target.value })}
              required
            />
            <TextField
              label="Designation"
              value={formData.designation}
              onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
              required
            />
            <TextField
              label="Specialization"
              value={formData.specialization}
              onChange={(e) => setFormData({ ...formData, specialization: e.target.value })}
              required
            />
            <input
              type="file"
              onChange={(e) => setFormData({ ...formData, photo: e.target.files[0] })}
              style={{ margin: "10px 0" }}
            />
            <Button type="submit" variant="contained" color="primary">
              {editingId ? "Update Staff" : "Add Staff"}
            </Button>
          </form>
        </CardContent>
      </Card>
      <TableContainer component={Paper}>
      <Table style={{ marginTop: "20px", maxWidth: "100%", overflowX: "auto" }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Qualification</TableCell>
            <TableCell>Designation</TableCell>
            <TableCell>Specialization</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {staff.map((s) => (
            <TableRow key={s.staff_id}>
              <TableCell>{s.name}</TableCell>
              <TableCell>{s.qualification}</TableCell>
              <TableCell>{s.designation}</TableCell>
              <TableCell>{s.specialization}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleEdit(s)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => handleDelete(s.staff_id)}>
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={100}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddStaff;
